import { loadAccounts } from "../common/api";

const model = {
    name: 'accounts',
    state: [],
    reducers: {
        loaded: ( state, payload ) => payload,
    },
    effects: ( dispatch ) => ( {
        async load() {
            const list = await loadAccounts();
            dispatch.accounts.loaded( list );
        }
    } )
}

export default model;